import {Layout} from 'antd';
import styles from './Sidebar.module.css';
import {useNavigate, useLocation} from 'react-router-dom';
import {authAPI} from "@/api";
import {useState} from 'react';
import {
    RocketOutlined,
    DashboardOutlined,
    ApiOutlined,
    ProjectOutlined,
    CodeOutlined,
    CloudServerOutlined,
    DatabaseOutlined,
    SettingOutlined,
    UserOutlined,
    GithubOutlined,
    DockerOutlined,
    ToolOutlined,
    LogoutOutlined,
    RightOutlined,
    LeftOutlined,
    AppstoreOutlined,
    BarChartOutlined,
    SafetyOutlined,
    GlobalOutlined,
    KeyOutlined,
    HistoryOutlined,
    ChromeOutlined,
    BugOutlined,
    MedicineBoxOutlined,
    MailOutlined,
    CloudDownloadOutlined
} from '@ant-design/icons';

const {Sider} = Layout;

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const isActive = (path) => {
        if (path === '/') return location.pathname === path;
        return location.pathname.includes(path);
    };

    const handleLogout = async () => {
        await authAPI.logout();
        window.location.reload();
    };

    const handleNavigate = (path) => {
        navigate(path);
        setActiveDropdown(null);
    };

    const toggleDropdown = (section) => {
        if (collapsed) return;
        setActiveDropdown(activeDropdown === section ? null : section);
    };

    const menuItems = [
        {
            key: 'dashboard',
            path: '/',
            icon: <DashboardOutlined/>,
            label: 'Дашборд',
            section: 'main'
        },
        {
            key: 'projects',
            icon: <ProjectOutlined/>,
            label: 'Проекты',
            section: 'main',
            dropdown: true,
            items: [
                {path: '/projects', label: 'Все проекты', icon: <AppstoreOutlined/>},
                {path: '/backups', label: 'Бэкапы', icon: <CloudDownloadOutlined/>},
                // { path: '/projects/active', label: 'Активные', icon: <RocketOutlined /> },
                // { path: '/projects/archive', label: 'Архив', icon: <DatabaseOutlined /> }
            ]
        },
        // {
        //   key: 'api',
        //   icon: <ApiOutlined />,
        //   label: 'API Management',
        //   section: 'development',
        //   dropdown: true,
        //   items: [
        //     { path: '/api/endpoints', label: 'Эндпоинты', icon: <CodeOutlined /> },
        //     { path: '/api/keys', label: 'API ключи', icon: <SafetyOutlined /> },
        //     { path: '/api/docs', label: 'Документация', icon: <ToolOutlined /> },
        //     { path: '/api/metrics', label: 'Метрики', icon: <BarChartOutlined /> }
        //   ]
        // },
        {
            key: 'microservices',
            icon: <CloudServerOutlined/>,
            label: 'Микросервисы',
            section: 'development',
            flat: true,
            items: [
                // {path: '/services/auth', label: 'Auth Service', icon: <SafetyOutlined/>, status: 'healthy'},
                // {path: '/services/users', label: 'Users API', icon: <UserOutlined/>, status: 'healthy'},
                // {path: '/services/analytics', label: 'Analytics', icon: <BarChartOutlined/>, status: 'warning'},
                // {path: '/services/gateway', label: 'API Gateway', icon: <ApiOutlined/>, status: 'healthy'},

                // VPN Manager — три страницы
                {path: '/services/vpn', label: 'VPN Dashboard', icon: <GlobalOutlined/>, status: 'healthy'},
                {path: '/services/vpn/keys', label: 'VPN Keys', icon: <KeyOutlined/>, status: 'healthy'},
                // {path: '/services/vpn/history', label: 'VPN History', icon: <HistoryOutlined/>, status: 'healthy'},

                // Ozon Browser (Camoufox)
                {path: '/services/ozon-browser', label: 'Ozon Browser', icon: <ChromeOutlined/>, status: 'healthy'},

                {path: '/services/ozon-events', label: 'Ozon события', icon: <BugOutlined/>, status: 'healthy'},

                {path: '/services/ehealth', label: 'Талоны', icon: <MedicineBoxOutlined/>, status: 'healthy'},

                // Email webhook (Cloudflare Email Routing)
                {path: '/services/email', label: 'Почта', icon: <MailOutlined/>, status: 'healthy'},
            ]
        },
        // {
        //   key: 'devops',
        //   icon: <DockerOutlined />,
        //   label: 'DevOps',
        //   section: 'tools',
        //   dropdown: true,
        //   items: [
        //     { path: '/devops/containers', label: 'Контейнеры', icon: <DockerOutlined /> },
        //     { path: '/devops/kubernetes', label: 'Kubernetes', icon: <DockerOutlined /> },
        //     { path: '/devops/ci-cd', label: 'CI/CD', icon: <ToolOutlined /> },
        //     { path: '/devops/monitoring', label: 'Мониторинг', icon: <BarChartOutlined /> }
        //   ]
        // },
        // {
        //   key: 'repositories',
        //   path: '/repos',
        //   icon: <GithubOutlined />,
        //   label: 'Репозитории',
        //   section: 'tools'
        // },
        // {
        //   key: 'databases',
        //   path: '/databases',
        //   icon: <DatabaseOutlined />,
        //   label: 'Базы данных',
        //   section: 'tools'
        // },
        // {
        //   key: 'settings',
        //   icon: <SettingOutlined />,
        //   label: 'Настройки',
        //   section: 'settings',
        //   dropdown: true,
        //   items: [
        //     { path: '/settings/profile', label: 'Профиль', icon: <UserOutlined /> },
        //     { path: '/settings/security', label: 'Безопасность', icon: <SafetyOutlined /> },
        //     { path: '/settings/api', label: 'API настройки', icon: <ApiOutlined /> },
        //     { path: '/settings/notifications', label: 'Уведомления', icon: <RocketOutlined /> }
        //   ]
        // }
    ];

    const renderMenuItem = (item) => {
        if (item.flat) {
            return item.items.map((subItem) => (
                <button
                    key={subItem.path}
                    title={subItem.label}
                    className={`${styles.navItem} ${isActive(subItem.path) && styles.active}`}
                    onClick={() => handleNavigate(subItem.path)}
                >
                    <span className={styles.navItemIcon}>{subItem.icon}</span>
                    {!collapsed && <span className={styles.navItemText}>{subItem.label}</span>}
                </button>
            ));
        }

        if (item.dropdown) {
            const isOpen = activeDropdown === item.key;

            return (
                <div key={item.key} className={styles.dropdownContainer}>
                    <button
                        className={`${styles.navItem} ${isOpen && styles.active}`}
                        onClick={() => toggleDropdown(item.key)}
                    >
                        <span className={styles.navItemIcon}>{item.icon}</span>
                        {!collapsed && (
                            <>
                                <span className={styles.navItemText}>{item.label}</span>
                                <span className={`${styles.dropdownArrow} ${isOpen && styles.rotated}`}>
                  <RightOutlined/>
                </span>
                            </>
                        )}
                    </button>

                    {!collapsed && isOpen && (
                        <div className={styles.dropdownMenu}>
                            {item.items.map((subItem) => (
                                <button
                                    key={subItem.path}
                                    className={`${styles.dropdownItem} ${isActive(subItem.path) && styles.active}`}
                                    onClick={() => handleNavigate(subItem.path)}
                                >
                                    <span className={styles.dropdownItemIcon}>{subItem.icon}</span>
                                    <span className={styles.dropdownItemText}>{subItem.label}</span>
                                    {subItem.status && (
                                        <span className={`${styles.statusBadge} ${styles[subItem.status]}`}/>
                                    )}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <button
                key={item.key}
                className={`${styles.navItem} ${isActive(item.path) && styles.active}`}
                onClick={() => handleNavigate(item.path)}
            >
                <span className={styles.navItemIcon}>{item.icon}</span>
                {!collapsed && <span className={styles.navItemText}>{item.label}</span>}
            </button>
        );
    };

    const renderSection = (title, items) => {
        if (items.length === 0) return null;

        return (
            <div className={styles.navSection}>
                {!collapsed && <h3 className={styles.sectionTitle}>{title}</h3>}
                {items.map(item => renderMenuItem(item))}
            </div>
        );
    };

    const mainItems = menuItems.filter(item => item.section === 'main');
    const devItems = menuItems.filter(item => item.section === 'development');
    const toolsItems = menuItems.filter(item => item.section === 'tools');
    const settingsItems = menuItems.filter(item => item.section === 'settings');

    return (
        <Sider
            width={collapsed ? 80 : 260}
            className={`${styles.sider} ${collapsed && styles.collapsed}`}
            collapsible={false}
        >
            <div className={styles.container}>
                {/* Логотип / Бренд */}
                <div
                    className={styles.logo}
                    onClick={() => handleNavigate('/')}
                >
                    <RocketOutlined className={styles.logoIcon}/>
                    {!collapsed && (
                        <>
                            <span className={styles.logoText}>DevSpace</span>
                            <span className={styles.logoBadge}>v2.0</span>
                        </>
                    )}
                </div>

                {/* Кнопка сворачивания */}
                <button
                    className={styles.collapseBtn}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    {collapsed ? <RightOutlined/> : <LeftOutlined/>}
                </button>

                {/* Основная навигация */}
                <nav className={styles.nav}>
                    {renderSection('Главная', mainItems)}
                    {renderSection('Разработка', devItems)}
                    {renderSection('Инструменты', toolsItems)}
                    {renderSection('Настройки', settingsItems)}
                </nav>

                {/* Нижняя панель с информацией о пользователе */}
                <div className={styles.footer}>
                    <div className={styles.userInfo}>
                        <div className={styles.userAvatar}>
                            <UserOutlined/>
                        </div>
                        {!collapsed && (
                            <div className={styles.userDetails}>
                                <span className={styles.userName}>Алексей</span>
                                <span className={styles.userRole}>Разработчик</span>
                            </div>
                        )}
                    </div>

                    <button className={styles.logoutButton} onClick={handleLogout}>
                        <LogoutOutlined/>
                        {!collapsed && <span>Выйти</span>}
                    </button>
                </div>
            </div>
        </Sider>
    );
};

export default Sidebar;